import "./less/my-products/index.less";
import { createRoot } from "react-dom/client";
import { applyPolyfills, defineCustomElements } from "@se/web-ui/loader";
import { App } from "./App";
import { isHostnameContainsCC } from "@pes-ui/utils";
import { _labelsStoreMock } from "./stores/config/__mocks__/labels.mock";

class MyProductsApp extends HTMLElement {
  connectedCallback() {
    const countryCode = isHostnameContainsCC()
      ? null
      : this.getAttribute("country-code");
    const languageCode = this.getAttribute("language-code");
    const isPublic = this.getAttribute("is-public");
    const appMountPoint = document.createElement("div");
    appMountPoint.setAttribute("id", "myProducts");
    this.append(appMountPoint);
    const root = createRoot(appMountPoint);
    root.render(
        <App 
          countryCode={countryCode} 
          languageCode={languageCode} 
          appMountPoint={appMountPoint} 
          isPublic = {JSON.parse(isPublic)}
        />);
  }  
}

customElements.define("pes-my-products-app", MyProductsApp);
applyPolyfills().then(defineCustomElements);
